module.exports = __webpack_public_path__ + "static/media/VIA3.581dd02e.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/VIA3.png
// module id = 1437
// module chunks = 1